<template>
  <JoinWrapper>
    <div class="box">
      <!-- PROGRESS BAR -->
      <JoinProgress :stage="stage" />
      <!-- / PROGRESS BAR -->

      <!-- 디폴트 화면-->
      <div class="topic">휴대폰 본인인증</div>
      <div
        v-if="!verifiedInfo && !isAlreadyRegistered && !isAlreadyWithdrawn"
        class="certification_default"
      >
        <a href="#" class="btn_cer_phone" @click="startPhoneVerification">
          휴대폰 본인인증하기
        </a>
      </div>
      <!-- 본인인증 결과 : 완료시-->
      <div v-if="verifiedInfo" class="complete_wrap">
        <div class="ph_img">
          <figure>
            <img src="@/assets/images/login_join/img_complete.png" alt="완료" />
            <figcaption>휴대폰 본인인증이<br />완료 되었어요</figcaption>
          </figure>
        </div>
      </div>
      <!-- 본인인증 결과 : 가입되어있을경우 -->
      <div
        v-if="isAlreadyRegistered || isAlreadyWithdrawn"
        class="already_wrap"
      >
        <div class="ph_img">
          <figure>
            <img
              src="@/assets/images/login_join/img_already.png"
              alt="이미가입"
            />
            <figcaption v-if="isAlreadyRegistered">
              이미 같은 번호로<br />가입된 정보가 있어요!
            </figcaption>
            <figcaption v-if="isAlreadyWithdrawn">
              해당 번호는 탈퇴된 계정에게 연결되어 있어요.<br />
              탈퇴일로부터 30일 동안은 재가입이 불가능합니다.<br />남은 기간
              이후에 다시 가입해 주세요.
            </figcaption>
          </figure>
        </div>
        <div v-if="isAlreadyWithdrawn" class="sub_info">
          재가입 가능일까지 {{ daysUntilRejoin }}일 남았습니다
        </div>
      </div>
      <div v-if="isAlreadyRegistered" class="btn_wrap">
        <router-link class="box_btn next_btn" to="/login/id_lost">
          아이디 찾으러 가기
        </router-link>
      </div>
      <div v-if="isAlreadyWithdrawn" class="btn_wrap">
        <router-link class="box_btn next_btn" to="/t">
          홈으로 돌아가기기
        </router-link>
      </div>
      <div v-if="!isAlreadyRegistered && !isAlreadyWithdrawn" class="btn_wrap">
        <button
          class="box_btn next_btn"
          :class="{ dull: !verifiedInfo }"
          :disabled="!verifiedInfo"
          @click="goToJoinStep3"
        >
          다음
        </button>
      </div>
    </div>
    <Iamport />
  </JoinWrapper>
</template>
<script>
import JoinWrapper from '@/components/auth/JoinWrapper.vue'
import JoinProgress from '@/components/auth/JoinProgress.vue'
import { v4 as uuidv4 } from 'uuid'
import { AUTH_GET_IMP_INFO } from '@/store/types'

export default {
  name: 'JoinStep2',
  components: {
    JoinWrapper,
    JoinProgress
  },
  data() {
    return {
      stage: 2,
      terms: null,
      verifiedInfo: null,
      isAlreadyRegistered: false,
      isAlreadyWithdrawn: false,
      contactMethods: this.$route.params.contactMethods,
      withdrawalDate: null
    }
  },
  computed: {
    paramsData() {
      return this.$route.params?.terms || ''
    },
    daysUntilRejoin() {
      const dateStr = this.withdrawalDate
      if (!dateStr) return 0
      const base = new Date(dateStr.split(' ')[0]) // "yyyy-MM-dd"
      const deadline = new Date(base)
      deadline.setDate(deadline.getDate() + 30)

      const today = new Date()
      today.setHours(0, 0, 0, 0)
      deadline.setHours(0, 0, 0, 0) // 정확한 날짜 비교를 위해 자정으로 맞춤

      return Math.max(0, Math.ceil((deadline - today) / 86400000))
    }
  },
  async mounted() {
    if (!this.paramsData) {
      this.$router.push({ name: 'sign_up' })
    }
    this.terms = await this.$store.dispatch('getCookie', 'ealice_mail1')
  },
  methods: {
    generateMerchantId() {
      return `ORD-${uuidv4()}`
    },
    async startPhoneVerification() {
      const terms = this.$route.params.terms
      window.IMP.certification(
        {
          merchant_uid: this.generateMerchantId(),
          popup: true
        },
        (rsp) => {
          if (rsp.success) {
            /* TODO: @stan Iamport does not have following required info in rsp.
            Will need to include imp_uid / merchant_uid to register user post data
              이름(name)
              성별(gender)
              생년월일(birth)
              개인식별 고유 키(unique_key)
              사이트 별 개인식별 고유 키(unique_in_site)
              phone
              carrier
              foreigner
            */
            this.$store
              .dispatch(AUTH_GET_IMP_INFO, rsp.imp_uid)
              .then((res) => {
                if (res.data.ok) {
                  const verifiedInfo = {
                    phone: res.data.result.phone,
                    name: res.data.result.name,
                    birthday: res.data.result.birthday,
                    gender: res.data.result.gender,
                    genderCode: res.data.result.genderCode,
                    // res 데이터
                    impUid: rsp.imp_uid,
                    merchantUid: rsp.merchant_uid,
                    // 상위then rsp 데이터
                    type: 'phone'
                  }
                  this.verifiedInfo = verifiedInfo
                  this.terms = terms
                }
              })
              .catch((err) => {
                // alert(err.response.data.errorState.message)
                this.isAlreadyRegistered = true
                console.log(err.response.data)
                if (err.response.data.errorState.code === 2033) {
                  this.isAlreadyWithdrawn = true
                  this.isAlreadyRegistered = false
                  this.withdrawalDate =
                    err.response.data.errorState?.extra?.withdrawalDate
                }
              })
          } else {
            /*
            error_code: "F0000"
            error_msg: "사용자가 인증을 취소하였습니다."
            imp_uid: "imp_356797789447"
            merchant_uid: "ORD-3ea4c201-ade7-4147-8d6b-881d1ff3fe67"
            pg_provider: "danal"
            pg_type: "certification"
            success: false
            const verifiedInfo = {
              impUid: 'imp_uid',
              merchantUid: 'merchant_uid',
              type: 'phone'
            }
            this.$router.push({
              name: 'join_step3',
              params: { terms, verifiedInfo }
            })
            */
          }
        }
      )
    },
    goToJoinStep3() {
      if (this.verifiedInfo && this.terms) {
        this.$router.push({
          name: 'join_step3',
          params: {
            terms: this.terms,
            verifiedInfo: this.verifiedInfo,
            contactMethods: this.contactMethods
          }
        })
      } else {
        alert('인증이 완료되지 않았습니다.')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.certification_default {
  margin: 234px 0 275px;
  text-align: center;
  .btn_cer_phone {
    display: inline-block;
    padding: 22px 60px;
    background-color: #008df3;
    border-radius: 12px;
    letter-spacing: 0;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 18px;
    color: #fff;
  }
}
.complete_wrap,
.already_wrap {
  margin: 209px 0 167px;
}
.ph_img {
  text-align: center;
  figure {
    > img {
      width: 68px;
      height: 122px;
    }
    > figcaption {
      display: block;
      margin: 59px 0 0;
      line-height: 30px;
      letter-spacing: 0;
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 18px;
      color: #333333;
    }
  }
}
.sub_info {
  text-align: center;
  font-family: 'pretendard-medium';
  font-weight: 600;
  font-size: 15px;
  color: #333333;
  margin: 30px 0 0;
}
@media (max-height: 667px) {
  .certification_default {
    margin: 180px 0 225px;
  }
  .complete_wrap,
  .already_wrap {
    margin: 150px 0 140px;
  }
}
</style>
